import { Box, Container, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import format from 'date-fns/format'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import PersonalizeOrder from '../components/personalize-order/PersonalizeOrder'
import {
  Menu,
  MenuPastOrders,
  MenuPopularItems,
  NavRestaurantCategories,
  OrderSidebar,
  ValidationModal,
} from '../components/place-order'
import { cancelEditingOrder, loadEditOrder, loadOrderCartStart } from '../redux/modules/cart'
import { loadDeliveryDropoffStart } from '../redux/modules/delivery'
import { loadFavoriteStart, loadPopularMenuItems } from '../redux/modules/favorite'
import { getFriendsOrdersStart } from '../redux/modules/friends'
import { loadLocationStart } from '../redux/modules/location'
import { clearMenuItem, loadMenuStart, selectMenuItem } from '../redux/modules/order'
import { addPastOrderToCart, loadPastOrdersStart } from '../redux/modules/pastorder'
import {
  getMenuInfoForNewPopularItems,
  getMenuInfoForPopularItems,
} from '../redux/modules/selectors'
import { pushAnalyticsEvent } from '../util/gtmUtils'
import { pushSnowplow, toOrderProcessSchema } from '../util/snowplow'
export class PagePlaceOrder extends Component {
  constructor(props) {
    super(props)
    const { clearMenuItem } = this.props
    clearMenuItem()
    this.handleClose = this.handleClose.bind(this)
  }

  handleClose() {
    this.props.clearMenuItem()
    this.props.cancelEditingOrder()
  }

  componentDidMount() {
    window && window.scrollTo(0, 0)
    const {
      loadDeliveryDropoffStart,
      loadFavoriteStart,
      loadLocationStart,
      loadMenuStart,
      loadOrderCartStart,
      loadPastOrdersStart,
      loadPopularMenuItems,
    } = this.props

    let {
      match: {
        params: { dropoffId = 0, locationId = 0 },
      },
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    if (locationId) {
      loadLocationStart(locationId)
      if (dropoffId) {
        loadMenuStart(dropoffId)
        loadDeliveryDropoffStart(dropoffId)
        loadOrderCartStart(dropoffId)
        loadPopularMenuItems()
        loadPastOrdersStart(dropoffId)
        loadFavoriteStart()
      }
    }
    pushAnalyticsEvent('Ordering', 'View Menu', undefined, dropoffId)
  }

  componentDidUpdate(prevProps) {
    const {
      deliveryDropoff,
      getFriendsOrdersStart,
      isAuthenticated,
      loadDeliveryDropoffStart,
      loadFavoriteStart,
      loadLocationStart,
      loadMenuStart,
      loadOrderCartStart,
      loadPastOrdersStart,
    } = this.props
    let {
      match: {
        params: { dropoffId = 0, locationId = 0 },
      },
    } = this.props
    dropoffId = Number(dropoffId)
    locationId = Number(locationId)

    if (locationId !== Number(prevProps.match.params.locationId)) {
      loadLocationStart(locationId)
    }
    if (dropoffId !== Number(prevProps.match.params.dropoffId)) {
      loadMenuStart(dropoffId)
      loadDeliveryDropoffStart(dropoffId)
      loadOrderCartStart(dropoffId)
    }
    if (isAuthenticated !== prevProps.isAuthenticated) {
      loadPastOrdersStart(dropoffId)
      loadFavoriteStart()
      loadMenuStart(dropoffId)
      loadDeliveryDropoffStart(dropoffId)
      loadOrderCartStart(dropoffId)
    }
    if (
      isAuthenticated &&
      deliveryDropoff &&
      prevProps.deliveryDropoff &&
      deliveryDropoff.deliveryDateTime !== prevProps.deliveryDropoff.deliveryDateTime
    ) {
      getFriendsOrdersStart(format(deliveryDropoff.deliveryDateTime, 'YYYY-MM-DD'), locationId)
    }
  }

  componentWillUnmount() {
    this.props.cancelEditingOrder()
  }

  render() {
    const {
      addPastOrderToCart,
      deliveryDropoff,
      deliveryError,
      friendHasOrdered,
      isDeliveryDropoffLoading,
      isEditingFromMenu,
      isEditingOrder,
      isEditingPastOrder,
      isLocationLoading,
      isMenuLoading,
      isOrderCartLoading,
      isPastOrderLoading,
      isWebpSupported,
      loadEditOrder,
      menu,
      menuItemForEdit,
      menuItemId,
      newPopularItems,
      pastOrderError,
      pastOrders,
      selectMenuItem,
    } = this.props

    let {
      match: {
        params: { dropoffId = 0, locationId = 0 },
      },
    } = this.props

    locationId = Number(locationId)
    dropoffId = Number(dropoffId)

    return (
      <>
        <Container maxWidth="lg" style={{ marginTop: '32px' }}>
          <Grid container justify="space-between" spacing={4}>
            <Grid item md={7} xs={12}>
              <Box marginBottom={4}>
                <NavRestaurantCategories
                  deliveryDropoff={deliveryDropoff}
                  isMenuLoading={isMenuLoading}
                />
              </Box>
              {isMenuLoading ||
              isDeliveryDropoffLoading ||
              isLocationLoading ||
              isMenuLoading ||
              isOrderCartLoading ? (
                <>
                  <LoadingState />
                  <LoadingState />
                </>
              ) : (
                <>
                  {/* Show past orders if you have them */}
                  {pastOrders && pastOrders.length > 0 && (
                    <MenuPastOrders
                      {...{
                        addPastOrderToCart,
                        editPastOrder: (
                          hash,
                          orderItemId,
                          isEditingPastOrder,
                          userId,
                          menuItemId,
                        ) => {
                          pushSnowplow(
                            toOrderProcessSchema(
                              'daily',
                              'order_again_menu_item_select',
                              menuItemId,
                              null,
                            ),
                          )
                          loadEditOrder(hash, orderItemId, isEditingPastOrder, userId, menuItemId)
                        },
                        isPastOrderLoading,
                        pastOrderError,
                        pastOrders,
                      }}
                    />
                  )}
                  {/* Show popular items if your building has */}
                  {newPopularItems && newPopularItems.length >= 1 && (
                    <MenuPopularItems
                      onSelectMenuItem={itemId => {
                        pushSnowplow(
                          toOrderProcessSchema(
                            'daily',
                            'popular_items_menu_item_select',
                            itemId,
                            null,
                          ),
                        )
                        selectMenuItem(itemId)
                      }}
                      popularItems={newPopularItems}
                    />
                  )}
                  <Menu
                    friendsHasOrdered={
                      friendHasOrdered &&
                      friendHasOrdered.filter(
                        order => order.dropoffId === Number(this.props.match.params.dropoffId),
                      )[0]?.friendsOrders
                    }
                    isWebpSupported={isWebpSupported}
                    menuData={menu}
                    onSelectMenuItem={itemId => {
                      pushSnowplow(
                        toOrderProcessSchema('daily', 'menu_menu_item_select', itemId, null),
                      )
                      selectMenuItem(itemId)
                    }}
                  />
                </>
              )}
            </Grid>
            {/* Left Nav start */}
            <Grid item md={4} xs={12}>
              <Box marginBottom={2}>
                <OrderSidebar />
              </Box>
            </Grid>
          </Grid>
        </Container>
        {/* Global Page Components */}
        {menuItemId && !isEditingPastOrder && !isEditingOrder && (
          <PersonalizeOrder
            dropoffId={dropoffId}
            handleClose={this.handleClose}
            menuId={menu && menu.menuId}
            menuItemForEdit={menuItemForEdit}
            menuItemId={menuItemId}
          />
        )}{' '}
        {isEditingPastOrder && menuItemForEdit && isEditingOrder && (
          <PersonalizeOrder
            dropoffId={dropoffId}
            handleClose={this.handleClose}
            isEditingFromMenu={isEditingFromMenu}
            isEditingOrder={isEditingOrder}
            menuId={menu.menuId}
            menuItemForEdit={menuItemForEdit}
            menuItemId={menuItemForEdit.menuItemId}
          />
        )}
        {deliveryError && (
          <ValidationModal
            deliveryDropoffId={dropoffId}
            locationId={locationId}
            serverMessage={deliveryError?.data}
          />
        )}
      </>
    )
  }
}

// should these live in the Page components or in the child?
const LoadingState = () => {
  return (
    <Box>
      <Box display="flex">
        <Skeleton height={80} width={250} />
      </Box>
      <Skeleton height={3} />
      <Box display="flex" justifyContent="space-between">
        <Skeleton height={50} width={150} />
        <Skeleton height={40} width={120} />
      </Box>
      <Skeleton />
      <Skeleton />
      <Skeleton width={200} />
      <Skeleton height={3} />
      <Box display="flex" justifyContent="space-between">
        <Skeleton height={50} width={150} />
        <Skeleton height={40} width={120} />
      </Box>
      <Skeleton />
      <Skeleton />
      <Skeleton width={200} />
      <Skeleton height={3} />
      <Box display="flex" justifyContent="space-between">
        <Skeleton height={50} width={150} />
        <Skeleton height={40} width={120} />
      </Box>
      <Skeleton />
      <Skeleton />
      <Skeleton width={200} />
      <Skeleton height={3} />
      <Box display="flex" justifyContent="space-between">
        <Skeleton height={50} width={150} />
        <Skeleton height={40} width={120} />
      </Box>
      <Skeleton />
      <Skeleton />
      <Skeleton width={200} />
    </Box>
  )
}

const mapStateToProps = state => {
  const { isMenuLoading, isOrderCartLoading, menu, menuItemId } = state.order
  const { deliveryDropoff, isDeliveryDropoffLoading } = state.delivery
  const { errorMessage: pastOrderError, isPastOrderLoading, pastOrders } = state.pastorder
  const {
    isEditingFromMenu,
    isEditingOrder,
    isEditingPastOrder,
    loadingOrderForEdit,
    menuItemForEdit,
  } = state.cart
  const { friendHasOrdered, isLoadingFriendsOrders } = state.friends
  const { isLoadingFavorites, isLoadingNewPopularMenuItems, isLoadingPopularItems } = state.favorite
  const { currentUser, isAuthenticated, isCurrentUserLoading } = state.user
  const popularItems = getMenuInfoForPopularItems(state)
  const newPopularItems = getMenuInfoForNewPopularItems(state)
  const { isLocationLoading } = state.location
  const deliveryError = state.delivery.error
  const orderError = state.order.error
  const { isWebpSupported } = state.browser

  return {
    currentUser,
    deliveryDropoff,
    deliveryError,
    friendHasOrdered,
    isAuthenticated,
    isCurrentUserLoading,
    isDeliveryDropoffLoading,
    isEditingFromMenu,
    isEditingOrder,
    isEditingPastOrder,
    isLoadingFavorites,
    isLoadingFriendsOrders,
    isLoadingNewPopularMenuItems,
    isLoadingPopularItems,
    isLocationLoading,
    isMenuLoading,
    isOrderCartLoading,
    isPastOrderLoading,
    isWebpSupported,
    loadingOrderForEdit,
    menu,
    menuItemForEdit,
    menuItemId,
    newPopularItems,
    orderError,
    pastOrderError,
    pastOrders,
    popularItems,
  }
}

const mapDispatchToProps = {
  addPastOrderToCart,
  cancelEditingOrder,
  clearMenuItem,
  getFriendsOrdersStart,
  loadDeliveryDropoffStart,
  loadEditOrder,
  loadFavoriteStart,
  loadLocationStart,
  loadMenuStart,
  loadOrderCartStart,
  loadPastOrdersStart,
  loadPopularMenuItems,
  selectMenuItem,
}

export default connect(mapStateToProps, mapDispatchToProps)(PagePlaceOrder)
